export const AUDIT_CATEGORY = {
  LINKS: 'links',
  VERIFY: 'verify',
  CONSENT: 'consent',
  VAULT: 'vault',
  INSURED: 'insured',
  INVOICE: 'invoice',
  ACH: 'ach',
  ORG: 'org',
  BILLING: 'billing',
  ACTIVITY: 'activity',
  CHANGES: 'changes',
} as const;

export type AuditCategoryType = (typeof AUDIT_CATEGORY)[keyof typeof AUDIT_CATEGORY];
export type AuditSourceType = 'domain' | 'api' | 'ui' | 'data' | 'system';

export type AuditEventType = {
  id: string;
  event: string;
  category: AuditCategoryType;
  category_label: string;
  source: AuditSourceType;
  actor_user_id: string | null;
  actor_label: string;
  actor_role: string;
  object_type: string;
  object_id: string | null;
  object_label: string;
  detail: string;
  transaction_ref: string;
  request_id: string | null;
  screen: string;
  date_created: string;
};

export type AuditEventDetailsType = AuditEventType & {
  data: Record<string, unknown>;
  ip: string | null;
  user_agent: string;
  http_method: string;
  path: string;
  url_name: string;
};

export type AuditCategoryCountType = {
  key: AuditCategoryType;
  label: string;
  count: number;
};

export type UIEventKindType = 'click' | 'navigate' | 'view';

export type UIEventType = {
  kind: UIEventKindType;
  label: string;
  screen: string;
  path: string;
  element?: string;
  at?: string;
  meta?: Record<string, string | number | boolean>;
};
